'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dictionary = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Dictionary, _Component);

  function Dictionary(props) {
    (0, _classCallCheck3.default)(this, Dictionary);
    return (0, _possibleConstructorReturn3.default)(this, (Dictionary.__proto__ || (0, _getPrototypeOf2.default)(Dictionary)).call(this, props));
  }

  (0, _createClass3.default)(Dictionary, [{
    key: 'returnWords',
    value: function returnWords(words) {
      var content = '';

      for (var i = words.length - 1; i >= 0; i--) {
        content = content + '<div class="word hiddenTxt animated"><h3>' + words[i].word + '</h3><p>' + words[i].desc + '</p></div>';
      }

      return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: content } });
    }
  }, {
    key: 'render',
    value: function render() {
      var text = this.props.strings.elems;

      return _react2.default.createElement(
        'div',
        { className: 'dictionaryContainer' },
        (0, _keys2.default)(text).map(function (key, index) {
          return _react2.default.createElement(
            'div',
            { key: 'letter' + key, className: 'letter' },
            _react2.default.createElement(
              'h2',
              { className: 'hiddenTxt animated' },
              ' ',
              text[key].letter
            ),
            this.returnWords(text[key].words)
          );
        }, this)
      );
    }
  }]);
  return Dictionary;
}(_react.Component), _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp);
;

exports.default = (0, _translate2.default)('Dictionary')(Dictionary);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Dictionary.js
// module id = 785
// module chunks = 0